import { render } from "./SuccessSessV.vue?vue&type=template&id=0c4d8c26&scoped=true"
import script from "./SuccessSessV.vue?vue&type=script&lang=js"
export * from "./SuccessSessV.vue?vue&type=script&lang=js"

import "./SuccessSessV.vue?vue&type=style&index=0&id=0c4d8c26&scoped=true&lang=css"

import exportComponent from "E:\\coding\\pharaoh_frog_barber\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4d8c26"]])

export default __exports__